export const theme = {
    colors: {
      text: '#fff',
      background: 'rgba(216,223,255,0.7)',
      primary: 'rgba(0, 0, 0, 0.54)',
      secondary: 'rgba(0, 0, 0, 0.50)',   
      accent: '#1976d2',
      warning: 'rgba(255,53,138,0.9)'
      
    },
    fonts: {
      body: 'system-ui, sans-serif',
      heading: 'system-ui, sans-serif',
      monospace: 'Menlo, monospace',
    },
    fontWeights: {
      body: 400,
      heading: 700,
      bold: 700,
    },
    lineHeights: {
      body: 1.5,
      heading: 1.125,
    },
    fontSizes: [12, 14, 16, 20, 24, 32, 48, 64],
    space: [0, 2, 4, 8, 16, 32, 64, 128, 256],
    borders: {
      none: 'none',
      medium: '1px solid palevioletred',
      normal: '1px solid',
    },
    radii: {
      none: '0',
      normal: '4px',
      medium: '20px',
      round: '50%',
    },
  
  };